import API from './API';
import { fetchPaged } from './crud';

export default {

  getMinuteByCar(carId,partnerId) {
    return API.get(`/minute?filter=car.id||$eq||${carId}&filter=partner.id||$eq||${partnerId}&`,{
      params: {
           join: [
            'partner',
            'car'
          ], 
        },
      });
  },

  getCustomersByPartner( partnerId ) {
    return API.get(`/customer?filter=partners.id||$eq||${partnerId}&filter=is_deleted||$eq||${false}&`, {
      params:{
         join:[
           'partners'
         ]
       }
     });
  },

  /**
   * Stessa lettura di `getCustomersByPartner`, ma PAGINATA.
   *
   * ⚠️ Ritorna `{ rows, total, truncated }`, NON una risposta axios, a
   * differenza della funzione qui sopra.
   *
   * Serve perche' senza `page` @nestjsx/crud risponde con un array nudo e
   * SENZA `total`: se i clienti superassero il tetto del backend
   * (MAX_CRUD_LIMIT), quelli in eccesso sparirebbero in silenzio e la tendina
   * sembrerebbe soltanto piu' corta. `truncated` lo rende dicibile. Vedi la
   * nota in `services/crud.js`.
   */
  async getCustomersByPartnerPaged( partnerId ) {
    return fetchPaged('/customer', {
      filter: [
        `partners.id||$eq||${partnerId}`,
        'is_deleted||$eq||false',
      ],
      join: ['partners'],
    });
  },

  addMinute(minute){
    return API.post('/minute', minute)
  },

  getCustomer(id) {
    return API.get('/customer/'+id);
  },

  checkCustomerExist(data) {
    return API.post('/customer/exist' , data)
  },

  
  addPartnerToCustomer(data) {
    return API.post('/customer/add-partner' , data)
  },

};